/**
 * URL base da API.
 * Em build: usa REACT_APP_API_BASE_URL do process.env.
 * Em runtime (ex: EasyPanel): usa window.__ENV.REACT_APP_API_BASE_URL injetado por config.js no index.html.
 * Assim dá para mudar a API só alterando variável de ambiente do container, sem rebuild.
 */
export function getApiBaseUrl() {
  if (typeof window !== "undefined" && window.__ENV?.REACT_APP_API_BASE_URL) {
    return window.__ENV.REACT_APP_API_BASE_URL;
  }
  return process.env.REACT_APP_API_BASE_URL || "";
}
